import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-override-modal',
  templateUrl: './override-modal.component.html',
  styleUrls: ['./override-modal.component.css'],
})
export class OverrideModalComponent {
  constructor(private activeModal: NgbActiveModal) {}

  closeClicked() {
    this.activeModal.close('close');
  }
}
